import { FC, ChangeEvent } from 'react'
import styles from 'styles/components/label.module.scss'
import InputText from 'components/Form/InputText'
import InputLabel from 'components/Label/InputLabel'

type Props = {
  required: boolean
  labelName: string
  labelSize?: string
  description: string
  line: number
  type: string
  size: string
  margin?: string
  value: string | number
  placeholder: string
  unit: string
  unitDescription?: string
  value2: string | number
  placeholder2: string
  unit2: string
  unitDescription2?: string
  readOnly2?: boolean
  errorText?: string | null
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onChange2?: (event: ChangeEvent<HTMLInputElement>) => void
  onInput?: () => void
  onInput2?: () => void
}

const InputTextAndUnitDoubleWithLabel: FC<Props> = (props) => {
  const {
    required,
    labelName,
    labelSize,
    description,
    line,
    type,
    size,
    margin,
    value,
    placeholder,
    unit,
    unitDescription,
    value2,
    placeholder2,
    unit2,
    unitDescription2,
    readOnly2,
    errorText,
    onChange,
    onChange2,
    onInput,
    onInput2,
  } = props

  const labelFormContainerStyle = (() => {
    switch (margin) {
      case 'default':
        return styles.labelFormContainer
      case 'narrow':
        return styles.labelFormContainerSub
      case 'min':
        return styles.labelFormContainerMin
      default:
        return styles.labelFormContainer
    }
  })()

  const className = `${labelFormContainerStyle}`

  return (
    <div className={className}>
      <InputLabel
        required={required}
        name={labelName}
        description={description}
        line={line}
        size={labelSize}
      />
      <div>
        <InputText
          required={required}
          type={type}
          size={size}
          value={value}
          placeholder={placeholder}
          rightAligned={true}
          errorText={errorText}
          onChange={(e) => (onChange ? onChange(e) : null)}
          onInput={onInput}
        />
      </div>
      <div className={styles.inputAndUnitTextContainer}>
        {unit}
        <br></br>
        {unitDescription}
      </div>
      <div className={styles.inputAndUnitTextContainer}>
        <InputText
          required={required}
          type={type}
          size={size}
          value={value2}
          placeholder={placeholder2}
          readOnly={readOnly2}
          rightAligned={true}
          onChange={(e) =>
            onChange2 ? onChange2(e) : onChange ? onChange(e) : null
          }
          onInput={onInput2 ? onInput2 : onInput}
        />
      </div>
      <div className={styles.inputAndUnitTextContainer}>
        {unit2}
        <br></br>
        {unitDescription2}
      </div>
    </div>
  )
}

export default InputTextAndUnitDoubleWithLabel
